import GeneralImageNew from '@gp/components/GeneralImageNew';
import {
  MILESTONE_CATEGORY_LIST,
  MILESTONE_KEY_LIST,
  DBG_SHOW_FOLLOW_TIPS_LOCAL_KEY,
} from '@gp/constants/const';
import BubbleClose from '@/pages/home/components/BubbleClose';
import {
  getPlatformIconList,
  getValidDate,
  notificationTips } from '@gp/utils/common';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Bubble, Button, Text } from 'tea-component';
import { useDispatch } from 'umi';
import DEFAULT_GAME from '@/pages/dashboard/assets/svg/mobile-game-default.svg';
import Slidebar from '@/pages/globalpedia/components/Slidebar';
import SvgIcon from '@/pages/home/components/SvgIcon';
import useClickoutside from '@gp/hooks/useClickoutside';
import {
  DETAIL_PROGRESS_TAG_MODEL_NAMESPACE,
} from '@gp/models/detailProgressTag';
import { useDeepCompareEffect } from 'ahooks';
import classnames from 'classnames';
import GameOverviewEdit from '../GameOverviewEdit';
import MilestonesTimelines from '../MilestonesTimelines';
import useMilestonesTimelines from '../MilestonesTimelines/hooks/useMilestonesTimelines';
import ProjectSwitcher from '../ProjectSwitcher';
import MilestoneLegend from './components/MilestoneLegend';
import { storage } from '@/utils/utils';
import { fetchAddProjectFollow, cancelProjectFollow, getProjectFollowStatus } from '@gp/services/projectDetail';
import { eventBus } from '@gp/utils/eventBus';
import SimpleModal from '@gp/components/SimpleModal';
import './index.scss';

const Header = (props: any) => {
  const {
    projectsLoading,
    projects,
    projectsRecordsLoading,
    projectsRecords,
    onPushProjectsRecord,
    detailInfo = {},
    currentProgress,
    userIsAbleEdit,
    activeId,
    style = {},
    showVisible,
    timeVisible,
    milestoneData,
    setActiveId,
    gameInformationDataRefresh,
    milestoneDataRefresh,
    projectsRecordsRefresh,
    projectsRefresh,
    currentProjectId,
    onSelectCurrentProjectId,
    showAddMilestoneBtn = false,
    setAddMilestoneVisible,
    milestoneCategory,
  } = props;

  const dispatch = useDispatch();
  const [milestoneLegendList, setMilestoneLegendList] = useState<any[]>([]);
  const [isAllMilestoneLegend, setIsAllMilestoneLegend] = useState<boolean>(false);
  const [isFollowing, setIsFollowing] = useState<boolean>(false);
  const [followingInfo, setFollowingInfo] = useState<any>({});
  const {
    isMilestonePage,
    isSame,
    timelineStep,
    timelines,
    timelineOffsetDistances,
    timelineUpdateDependencies,
  } = useMilestonesTimelines({
    activeId,
    detailInfo,
    showVisible,
    timeVisible,
    milestoneData,
    setActiveId,
    milestoneCategory,
  });

  const stageBadgeRef = useRef(null);
  const badgeListRef = useRef<any[]>([]);

  const followTipsStatus = storage.getItem(DBG_SHOW_FOLLOW_TIPS_LOCAL_KEY);
  // 是否显示tips
  const [showTips, setShowTips] = useState<boolean>(!followTipsStatus);
  const [timelinesWidth, setTimelinesWidth] = useState(0);
  const [visible, setVisible] = useState(false); // 弹窗
  const [visibleDelete, setVisibleDelete] = useState(false); // 弹窗
  const root = useRef<HTMLDivElement>(null);
  // 用于点击搜索框清空按钮及搜索按钮时，不关闭弹窗
  const stopChangeOpenRef = useRef<boolean>(false);

  useEffect(() => {
    dispatch({
      type: `${DETAIL_PROGRESS_TAG_MODEL_NAMESPACE}/updateProgress`,
      payload: currentProgress,
    });
  }, [currentProgress]);

  const getFollowingHandle = async () => {
    if(currentProjectId) {
      try {
        const params = { project_id: currentProjectId, type: 1 };

        const res = await getProjectFollowStatus(params);
        if(res?.data?.id) {
          // 收藏
          setIsFollowing(true);
          setFollowingInfo(res?.data);
        } else {
          setIsFollowing(false);
          setFollowingInfo({});
        }
      } catch (exception) {
      } finally {
      }
    }
  };

  useEffect(() => {
    if (!detailInfo) return;
    const newBadgeList = [
      {
        id: 2,
        content: `Next Milestone：${detailInfo.next_milestone
          ? detailInfo.next_milestone +
          (detailInfo.next_milestone_date
            ? `(${getValidDate(detailInfo.next_milestone_date, 'YYYY-MM-DD')})`
            : '-')
          : '-'
        }`,
      },
      {
        id: 3,
        content: `Official Launch：${detailInfo.official_launch ? getValidDate(detailInfo.official_launch, 'YYYY-MM-DD') : '-'
        }`,
      },
    ];
    badgeListRef.current = newBadgeList;
    handleToggleIsBubble();
  }, [detailInfo]);

  useEffect(() => {
    // 获取收藏状态
    getFollowingHandle();

    // 监听收藏刷新事件
    const unsubscribe = eventBus.on('favorite-project:refresh-project', () => {
      getFollowingHandle();
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const handleToggleIsBubble = () => {
    const newBadgeList = badgeListRef?.current?.map((item, index) => {
      return {
        ...item,
        isBubble:
          stageBadgeRef.current?.childNodes[index]?.scrollWidth >
          stageBadgeRef.current?.childNodes[index]?.clientWidth,
      };
    });
    badgeListRef.current = newBadgeList;
  };

  useEffect(() => {
    window.addEventListener('resize', handleToggleIsBubble);

    return () => {
      window.removeEventListener('resize', handleToggleIsBubble);
    };
  }, []);

  // 判断下拉框是否去关闭
  useClickoutside(root?.current, 'click', () => {
    // 确保这里最后执行
    const timer = setTimeout(() => {
      if (stopChangeOpenRef.current) {
        stopChangeOpenRef.current = false;
        return;
      }
      clearTimeout(timer);
    }, 100);
  });

  const handleAddMilestone = () => {
    setAddMilestoneVisible?.(true);
  };

  const handleCancelFollowFun = async () => {
    const params = { id: followingInfo?.id };
    const res = await cancelProjectFollow(params);
    if(res?.code === 200) {
      // 取消收藏成功
      setIsFollowing(false);
      notificationTips(
        'success',
        `${detailInfo.project} has removed from my Favorite Project.`,
        5000,
      );
      // 通知收藏列表刷新
      eventBus.emit('favorite-project:refresh');
    }
  };

  const clickFollowingHandle = async (isFollowing: boolean) => {
    try {
      if(isFollowing) {
        if(followingInfo?.id) {
          setVisibleDelete(true);
        }
      } else {
        if(currentProjectId) {
          const params = { project_id: currentProjectId, type: 1 };

          const res = await fetchAddProjectFollow(params);
          if(res?.code === 200) {
            setFollowingInfo(res?.data);
            // 收藏成功
            setIsFollowing(true);
            notificationTips(
              'success',
              'The project has been successfully added to my Favorite Project.',
              5000,
            );
            // 通知收藏列表刷新
            eventBus.emit('favorite-project:refresh');
          }
        }
      }
    } catch (exception) {
    } finally {
    }
  };

  const onCloseTips = (): void => {
    storage.setItem(DBG_SHOW_FOLLOW_TIPS_LOCAL_KEY, 'true');
    setShowTips(false);
  };

  useDeepCompareEffect(() => {
    const list = timelines || [];
    const arrTemp = list?.map((item: any) => {
      return item.category;
    });
    const uniqueArray = [...new Set(arrTemp)];

    // 先判断三个主KEY中是否有
    const hasMainKey = uniqueArray.some((item: any) => MILESTONE_KEY_LIST.includes(item));
    const resList: any = [];
    MILESTONE_CATEGORY_LIST?.forEach((item: any) => {
      if (hasMainKey) {
        if (MILESTONE_KEY_LIST?.includes(item.key)) {
          resList.push(item.key);
        }
      } else {
        if (!MILESTONE_KEY_LIST?.includes(item.key)) {
          resList.push(item.key);
        }
      }
    });
    setMilestoneLegendList(resList);
  }, [timelines]);

  const timelinesCur = useMemo(() => {
    const list = timelines || [];
    if (isAllMilestoneLegend) {
      return list;
    }
    const listTemp = list?.filter((item: any) => milestoneLegendList?.includes(item.category));
    return listTemp;
  }, [timelines, milestoneLegendList, isAllMilestoneLegend]);

  const followBubbleFun = useCallback(() => {
    const contentValue = isFollowing ? 'Remove from Favorite Project' : 'Add to Favorite Project';

    const domValue = <i className="dbg-project-detail-header-star" onClick= {(e) => {
      e.stopPropagation();
      clickFollowingHandle(isFollowing);
    } }>
      <SvgIcon
        className={isFollowing ? 'action-icon' : ''}
        type={isFollowing ? 'star-action' : 'star-m'}
      />
    </i>;

    const bubbleCloseProps = {
      visible: showTips,
      content: contentValue,
      placement: "top",
      onClose: onCloseTips,
      id: 'demographics-table-tips-overlay',
    } as any;

    return <>{followTipsStatus ? <Bubble
      className="bubble-all-bg"
      arrowPointAtCenter
      dark
      placement="top"
      content={contentValue}
    >
      {domValue}
    </Bubble> : <BubbleClose
      {...bubbleCloseProps}
    >
      {domValue}
    </BubbleClose>
    }</>;

  }, [isFollowing, followTipsStatus, showTips, followingInfo]);

  return (
    <>
      <div className="dbg-project-detail-header" style={style}>
        <div className="dbg-header-bg">
          <div
            className="dbg-header-bg-img"
            style={{
              backgroundImage: `url("${detailInfo?.cover || DEFAULT_GAME}")`,
            }}
          ></div>
        </div>
        <div className="dbg-project-detail-header-ct">
          <div className="dbg-project-detail-header-img">
            <GeneralImageNew domain="game" src={detailInfo.cover} width={72} height={72} />
          </div>
          <div className="dbg-project-detail-header-context">
            <div className="dbg-context-flex">
              <div className="dbg-project-detail-header-left">
                <ProjectSwitcher
                  projectsLoading={projectsLoading}
                  projects={projects}
                  projectsRecordsLoading={projectsRecordsLoading}
                  projectsRecords={projectsRecords}
                  onPushProjectsRecord={onPushProjectsRecord}
                  name={detailInfo.project || '-'}
                  value={currentProjectId || ''}
                  onChange={onSelectCurrentProjectId}
                />
                {/* 收藏功能 */}
                {followBubbleFun()}
                {userIsAbleEdit && (
                  <div
                    className="dbg-project-edit dbg-project-edit--text"
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    <span>Edit</span>
                  </div>
                )}
              </div>
            </div>
            <div className="dbg-context-time">
              {detailInfo?.platform &&
              detailInfo?.platform?.length &&
              getPlatformIconList(detailInfo?.platform)?.map((t: string, i: number) => {
                return (
                  <SvgIcon
                    key={i}
                    // 后期开发处理，重构暂时更改
                    type={
                      {
                        mobile: 'other-icon',
                        pc: 'monitor',
                        console: 'game',
                      }[t]
                    }
                    className="dbg-project-icon"
                  />
                );
              })}
              <div className="dbg-context-box">
                <Text className="dbg-text-size">
                Stage：
                  <span>
                    {detailInfo.stage
                      ? detailInfo.stage[0]?.toUpperCase() + detailInfo.stage?.substr(1)
                      : '-'}
                  </span>
                </Text>
              </div>
            </div>
            {showVisible ? (
              <div className="dbg-milestones-notext">
              This project has no milestone information yet.
                {!showAddMilestoneBtn ? null : (
                  <>
                    {' '}
                  Please click to{' '}
                    <Button
                      className={classnames('dbg-milestones-notext-btn', {
                        normal: isMilestonePage,
                      })}
                      type="link"
                      onClick={handleAddMilestone}
                    >
                    Add new Milestone
                    </Button>
                  </>
                )}
              </div>
            ) : (
              <div className={`dbg-milestones-timeline`}>
                <div className="dbg-milestones-timeline-context">
                  <Slidebar
                    className="dbg-milestones-timeline-slidebar"
                    listNodeClassName="milestones-timeline"
                    offsetDistances={timelineOffsetDistances}
                    updateDependencies={timelineUpdateDependencies}
                    milestoneLegendList={milestoneLegendList}
                    timelinesWidth={timelinesWidth}
                  >
                    <MilestonesTimelines
                      timelines={timelines}
                      timelinesCur={timelinesCur}
                      isSame={isSame}
                      current={timelineStep}
                      stage={detailInfo?.stage}
                      getTimelineOffsetMsg={() => { }}
                      milestoneCategory={milestoneCategory}
                      setTimelinesWidth={setTimelinesWidth}
                      milestoneLegendList={milestoneLegendList}
                    />
                  </Slidebar>
                </div>
                <MilestoneLegend
                  timelines={timelines}
                  milestoneLegendList={milestoneLegendList}
                  setMilestoneLegendList={setMilestoneLegendList}
                  isAll={isAllMilestoneLegend}
                  setIsAll={setIsAllMilestoneLegend}
                />
              </div>
            )}
          </div>
        </div>

        <GameOverviewEdit
          visible={visible}
          {...{
            gameInformationDataRefresh,
            milestoneDataRefresh,
            projectsRecordsRefresh,
            projectsRefresh,
            ...props,
          }}
          close={() => {
            setVisible(false);
          }}
        />
      </div>

      <SimpleModal
        className="dbg-dps-report-submit-confirm-modal"
        title={'Do you want to remove this project from Favorites?'}
        visible={visibleDelete}
        description={null}
        size={600}
        onClose={() => {
          setVisibleDelete(false);
        } }
        footer={<>
          <Button
            type="primary"
            onClick={(e) => {
              e?.stopPropagation();
              setVisibleDelete(false);
              handleCancelFollowFun?.();
            }}
          >
            Confirm
          </Button>
          <Button
            onClick={(e) => {
              e?.stopPropagation();
              setVisibleDelete(false);
            } }
          >
            Cancel
          </Button>
        </>}
      />
    </>
  );
};

export default Header;
